import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-subnav-arrow',
    templateUrl: '../svgs/ArrowSubnav.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--subnav-arrow'
    },
    standalone: false
})
export class TellerOnlineIconSubnavArrow {
}
